import React, { lazy } from 'react'

const FormInfoPage = lazy(() => import('./FormInfoPage'))

export { FormInfoPage }
